import Vue from 'vue';
import searchBoxComponent from '../../components/common/searchbox.vue';

import { initialize } from '../../util/sentry';
initialize(Vue);

new Vue({
  el: '#vue-search-box',
  components: {
    'vue-search-box': searchBoxComponent
  }
});
